<template>
  <div class="section-bills-list section-full">
    <h2 class="ttl2 popup-header" v-translate >Bill Details</h2>
    <bills-table :bills="bills" @billClicked="showBillModal"/>
  </div>
</template>

<script>
import BillsTable from '@/components/BillsTable.vue';
import { TOGGLE_BILL_MODAL_VISIBLE } from '@/store/mutation-types';

export default {
  name: 'BillsDetail',
  components: {
    BillsTable,
  },
  computed: {
    bills() { return this.getArray('bills').reverse() },
  },
  created() {
    // autoload articles
    const articles = this.getArray('articles');
  },
  methods: {
    showBillModal(bill) {
      bill = this.getObject(bill.id, 'bills');
      this.$store.state.bill.billModal = 'detail';
      this.$store.dispatch('setBill', Object.assign({}, bill));
      this.$store.commit(TOGGLE_BILL_MODAL_VISIBLE);
    },
  },
};
</script>
